/*
 *NOTE: we can reuse this singleton Module to share some general variables across the components
 */
 export const InitData = (function () {
    // Instance stores a reference to the Singleton
    let instance;
    function init() {
      // Singleton
      // Private methods and variables
      let _onAuthState = '';
      let _apiPrefix = '';
      let _authorization = '';
      let _apikey = '';
      return {
        // Public methods and variables
        setOnAuthState: function (onAuthState) {
          _onAuthState = onAuthState;
          console.log(`setOnAuthState ${_onAuthState}`);
        },
        getOnAuthState: function () {
          console.log(`getOnAuthState ${_onAuthState}`);
          return _onAuthState;
        },
        setApiPrefix: function (apiPrefix) {
          _apiPrefix = apiPrefix;
        },
        getApiPrefix: function () {
          return _apiPrefix;
        },
        setAuthorization: function (authorization) {
          _authorization = authorization;
        },
        getAuthorization: function () {
          return _authorization;
        },
        setApiKey: function (apikey) {
          _apikey = apikey;
        },
        getApiKey: function () {
          return _apikey;
        },
      };
    }
    return {
      // Get the Singleton instance if one exists
      // or create one if it doesn't
      getInstance: function () {
        if (!instance) {
          instance = init();
        }
        return instance;
      },
    };
  })();